var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('input',{ref:"input",attrs:{"type":"file","hidden":""},on:{"change":function($event){return _vm.submitUpload()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }